import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type OfferStatusEventPayloadFragment = (
  { readonly __typename?: 'OfferStatusEvent' }
  & Pick<TP.OfferStatusEvent, 'id' | 'type' | 'routeId' | 'carrierId' | 'offerStatus' | 'offerType'>
);

export const OfferStatusEventPayloadFragmentDoc = gql`
    fragment OfferStatusEventPayload on OfferStatusEvent {
  id
  type
  routeId
  carrierId
  offerStatus
  offerType
}
    `;